enum TokenConstants {
  PATIENT_ID = 'ext_patientId',
  SHOW_SCHEDULING_DURATION = 'ext_show_scheduling_duration',
  IE_DISP_CALENDARIO = 'ext_ie_disp_calendario',
  IE_LISTA_ESP_CONSULTA = 'ext_ie_lista_esp_consulta',
  IE_LISTA_ESP_EXAME = 'ext_ie_lista_esp_exame',
  IE_SHOW_TELEHEALTH_RECORDS = 'ext_ie_show_telehealth_records',
}

export default TokenConstants;
